export default function NumericHelperService() {

  function IsEven(value: number): boolean {
    return value % 2 === 0;
  }

  function isOdd(value: number): boolean {
    return !IsEven(value);
  }

  function numericNOT(a: readonly number[] = [], b: readonly number[] = []) {
    return a.filter((value) => b.indexOf(value) === -1);
  }

  function numericINTERSECT(a: readonly number[] = [], b: readonly number[] = []) {
    return a.filter((value) => b.indexOf(value) !== -1);
  }

  // ---
  return {
    IsEven, isOdd,
    numericNOT, numericINTERSECT
  }
}